import { render, staticRenderFns } from "./fill-bussines-details.vue?vue&type=template&id=c4f58780&scoped=true"
import script from "./fill-bussines-details.vue?vue&type=script&lang=js"
export * from "./fill-bussines-details.vue?vue&type=script&lang=js"
import style0 from "./fill-bussines-details.vue?vue&type=style&index=0&id=c4f58780&prod&lang=css&scoped=true"
import style1 from "./fill-bussines-details.vue?vue&type=style&index=1&id=c4f58780&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4f58780",
  null
  
)

export default component.exports